import {
  Loading
} from 'element-ui'

// 封装 element-ui 的 loading 事件

const loading = (that, obj) => {
  if (obj == 'start') {

    that.loadingInstance = Loading.service({
      fullscreen: true,
      target: 'document.body',
      lock: true,
      text: '加载中',
      background: 'rgba(255, 255, 255, .8)'
    })
  } else if (obj == 'close') {
    // 以服务的方式调用的 Loading 需要异步关闭
    that.$nextTick(() => {
      that.loadingInstance.close()
    })
  }
}


export default loading



// WEBPACK FOOTER //
// ./src/common/loading.js